module.exports = __webpack_public_path__ + "static/img/banner.41f44e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepageComponent/images/banner.jpg
// module id = i9jd
// module chunks = 6